<template>
  <AppHeaderDropdown right no-caret class="mr-1">
    <template slot="header">
        <img src="img/avatars/default.png" class="img-avatar" >
        <span class="d-sm-down-none">{{user.username}}</span>
    </template>

    <template slot="dropdown">
      <!-- <b-dropdown-header tag="div" class="thin-border">
        <strong>Hi, {{user.username}}</strong>
      </b-dropdown-header> -->
      <b-dropdown-item @click="linkClick(menu)" class="thin-border" v-for="(menu, idx) in menus" :key="idx">{{menu.title}}</b-dropdown-item>
      <b-dropdown-item @click="signout">Sign Out</b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<style lang="scss" scoped>
.thin-border {
  border-bottom: 1px solid rgba(0, 0, 0, 0.04);
}
.dropdown-item {
  padding: 8px 20px;
  color: #73818f;
}
</style>

<script>
import { HeaderDropdown as AppHeaderDropdown } from "@coreui/vue";
// import auth from "../apis/auth.js";

export default {
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return {
      menus: [],
      user: {
        username: "invalid",
        email: "invalid@mail.com"
      }
    };
  },
  created: async function() {
    this.menus = [
      { title: "List ERP Modules", name: "app.modules" },
      { title: "Pending Approval/Task", name: "app.approval" },
      { title: "Material Requisition", name: "app.requisition" },
      { title: "Serah Terima Dokumen", name: "app.circulationdocument" },
      { title: "Catatan Pemakaian Dana", name: "app.expensesnote" },
      { title: "User Profile", name: "app.profile" }
    ];
    try {
        // this.user = await auth.me();
        this.user = this.$store.state.user;

        // if (!(this.user)) {
        //   this.$router.push({ name: "page.login" });
        // }      
    } catch (error) {
      console.log('Account Component: ',error);
    }
  },
  methods: {
    linkClick(menu) {
      if (menu.name) this.$router.push({ name: menu.name });
    },
    signout() {
      localStorage.clear();
      // this.$router.push("/");
      location.href = "/";
    }
  }
};
</script>
